// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nuxt/webpack/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".message__title[data-v-bd5b260a]{margin:0}.message__text[data-v-bd5b260a]{padding:1rem}", ""]);
// Exports
module.exports = exports;
